<app-header></app-header>

<div class="h-[86px]"></div>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<p-toast key="toast"></p-toast>

<!-- <p-confirmDialog></p-confirmDialog> -->

<app-loader></app-loader>
